import * as React from 'react';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import Button from "@mui/material/Button";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { styled } from "@mui/material/styles";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import * as util from "../../utils/util";
import { BarChart } from '@mui/x-charts/BarChart';
import api from "../../utils/api";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import FlatwareIcon from "@mui/icons-material/Flatware";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));


const HealthResultCompare = (props: any) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  type Anchor = 'bottom'
  const [state, setState] = React.useState({
    bottom: false,
  });
  const [alignment, setAlignment] = React.useState('all');
  const [resultData, setResultData] = React.useState([]);
  const [resultItemData, setResultItemData] = React.useState([]);
  const [totalResult, setTotalResult] = React.useState<string[]>([]);
  const [categoryA, setCategoryA] = React.useState<string[]>([]);
  const [categoryB, setCategoryB] = React.useState<string[]>([]);
  const [categoryC, setCategoryC] = React.useState<string[]>([]);

  useEffect(() => {

    const comparePrevYear = 5;
    const currentYear = new Date().getFullYear();
    const userCusID = localStorage.getItem('userCusID') || '';
    api.post('customer/api/v1/CU_005_001', { cusId: userCusID }).then(res => {
      if (res.data.length > 0) {
        for (let tp of res.data) {
          if (tp.famId === localStorage.getItem('ownerFamID') || '') {  // 본인 검진 결과만 조회
            api.post('customer/api/v1/CU_005_002', { famId: tp.famId }).then(res => {
              let resultTemp = res.data.map((v: any) => true ? { ...v, famName: tp.famName, famId: tp.famId } : v);
              setResultData((prev) => prev.concat(resultTemp.filter((v: any) => Number(v.year.substring(0, 4)) > (currentYear - comparePrevYear))));

              const tempResultItemList = resultTemp
                .filter((v: any) => Number(v.year.substring(0, 4)) > (currentYear - comparePrevYear))
                .map((v: any) => v.resultItemList.map((vv: any) => true ? { ...vv, year: v.year.substring(0, 4) } : vv))
                .flat();

              setResultItemData((prev) => prev.concat(tempResultItemList));

              const resultByCategoryA = tempResultItemList.reduce((acc: any, curr: any) => {
                const { categoryA } = curr;
                if (acc[categoryA]) acc[categoryA].push(curr);
                else acc[categoryA] = [curr];
                return acc;
              }, {});
              setCategoryA(Object.keys(resultByCategoryA));

              const resultByCategoryB = tempResultItemList.reduce((acc: any, curr: any) => {
                const { categoryB } = curr;
                if (acc[categoryB]) acc[categoryB].push(curr);
                else acc[categoryB] = [curr];
                return acc;
              }, {});
              setCategoryB(Object.keys(resultByCategoryB));

              const resultByCategoryC = tempResultItemList.reduce((acc: any, curr: any) => {
                const { ipCode } = curr;
                if (acc[ipCode]) acc[ipCode].push(curr);
                else acc[ipCode] = [curr];
                return acc;
              }, {});
              setCategoryC(Object.keys(resultByCategoryC));

            }).catch(function (error) {
              console.log(error)
            });
          }
        }
      }
    }).catch(function (error) {
      console.log(error)
    });

  }, []);

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };



  return (
    <React.Fragment>
      {(['bottom'] as const).map((anchor) => (
        <React.Fragment key={anchor}>

          {props.componentName === '최근 3년 검진결과 보기' ? (
            <Box sx={{ flex: 3, textAlign: 'center', bgcolor: '#0d6703', p: 1 }} onClick={handleClickOpen}>
              <Typography sx={{ fontWeight: 700, color: '#fff' }}>최근 3년 검진결과 보기 <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#fff' }} /></Typography>
            </Box>
          ) : (
            <Button onClick={handleClickOpen} sx={{ p: '5px 0px', width: 500 }}>
              <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#0d6703' }}> {props.componentName.replaceAll('<br />', ' / ')}<KeyboardArrowRightIcon sx={{ verticalAlign: 'top', fontSize: 20 }} /></Typography>
            </Button>
          )}
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
          >
            <DialogTitle sx={{ m: 0, p: 2, fontWeight: 'bold' }} id="customized-dialog-title">
              {props.componentName.replaceAll('<br />', ' / ')}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers sx={{ width: 800 }}>

              <Box
                sx={{ pb: 7, }}
                role="presentation"
                onKeyDown={toggleDrawer(props.anchor, false)}
              >
                {/* <Stack direction={'row'} justifyContent={'center'} mb={1} p={2} sx={{ position: 'fixed', width: '100%', bgcolor: '#fff', zIndex: 1, boxSizing: 'border-box', borerBottom: '1px solid #ccc' }}>
                  <Typography sx={{ fontSize: 18, fontWeight: 700, ml: 'auto', }}></Typography>
                  <Typography sx={{ fontSize: 18, fontWeight: 700, ml: 'auto', mr: 1, color: '#777' }} onClick={toggleDrawer(props.anchor, false)}>X</Typography>
                </Stack> */}


                <React.Fragment>
                  <Box sx={{ bgcolor: '#fff', p: 1, textAlign: 'right', pr: 2 }}>
                    <Typography sx={{ fontSize: 14, }}>검진항목 <Typography component={'span'} sx={{ fontSize: 14, fontWeight: 700 }}>{resultItemData.length}</Typography>개</Typography>
                  </Box>
                  <Divider />

                  {categoryB.length <= 0 ? (
                    <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 10, }}>
                      <EventBusyIcon sx={{ fontSize: 50, color: '#bbb', pb: 10 }} />
                      <Typography sx={{ fontSize: 16, color: '#888' }} >{props.componentName.replaceAll('<br />', ' / ')} 정보가 없습니다.</Typography>
                    </Stack>
                  ) : (

                    <React.Fragment>

                      {categoryA && categoryA.map((itemA: any, index: any) => (
                        <Box sx={{ mt: 3, }}>
                          <Typography pl={3} sx={mainTitle}>{itemA}</Typography>
                          <Box sx={{ p: 2, bgcolor: '#f9f9f9', }}>

                            {categoryB && categoryB.map((itemB: any, index1: number) => (
                              <React.Fragment>

                                {resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB).map((item: any, index11: number) => (
                                  index11 === 0 ? <Divider sx={titleDivider} >{itemB}</Divider> : null
                                ))}

                                {categoryC && categoryC.map((itemC: any, index: any) => (
                                  <React.Fragment>

                                    {resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((item: any, index: number) => (
                                      index === 0 ? (
                                        <React.Fragment>

                                          {item.resultCase === 'A' ? (
                                            <React.Fragment>

                                              <Card sx={resultBox}>
                                                <Typography sx={resultTitle}>{item.inspection}</Typography>
                                                <Divider sx={{ mt: 1 }} />

                                                <Stack direction={'row'} justifyContent={'space-around'} mt={1}>
                                                  {resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((itemSub: any, index: any, { length }) => (
                                                    <React.Fragment>
                                                      <Box sx={{ textAlign: 'center' }}>
                                                        <Chip label={itemSub.year} size='small' />
                                                        <Typography sx={result}>{util.strNull(itemSub.result).trim() !== '' ? itemSub.result : '-'}
                                                          <Typography component={'span'} sx={resultUnit}>{itemSub.unit}</Typography>
                                                        </Typography>
                                                      </Box>
                                                      {index + 1 !== length ? (<Divider orientation="vertical" flexItem sx={divider} />) : null}
                                                    </React.Fragment>
                                                  ))}
                                                </Stack>
                                              </Card>

                                            </React.Fragment>
                                          ) : (
                                            <React.Fragment>

                                              <Card sx={resultChartBox}>

                                                {/* {item.resultCase === 'B' ? (
                                                <Box sx={{ mt: 1 }}>
                                                  <Box sx={{ width: '100%', textAlign: 'center' }}>
                                                    <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 15px)`, }}>
                                                      <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {item.result}</Typography>
                                                      <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                                    </Box>
                                                  </Box>
                          
                                                  <Grid container spacing={0} height={10} sx={{ mt: -1.5, mb: 1 }}>
                                                    <Grid item xs={4} bgcolor={'rgb(189,186,26)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                      낮음
                                                    </Grid>
                                                    <Grid item xs={4} bgcolor={'rgb(29,159,55)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                      정상
                                                    </Grid>
                                                    <Grid item xs={4} bgcolor={'rgb(229,36,36)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                      높음
                                                    </Grid>
                                                  </Grid>
                          
                                              
                                                </Box>
                          
                          
                                              ) : (
                                                <Box sx={{ mt: 1 }}>
                                                  <Box sx={{ width: '100%', textAlign: 'center' }}>
                                                    <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 15px)`, }}>
                                                      <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {item.result}</Typography>
                                                      <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                                    </Box>
                                                  </Box>
                          
                                                  <Grid container spacing={0} height={10} sx={{ mt: -1.5, mb: 1 }}>
                                                    <Grid item xs={6} bgcolor={'rgb(229,36,36)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                      비정상
                                                    </Grid>
                                                    <Grid item xs={6} bgcolor={'rgb(29,159,55)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                      정상
                                                    </Grid>
                                                  </Grid>
                                                </Box>
                                                
                                              )} */}

                                                {/* 3개년 비교 */}
                                                <Typography sx={resultTitle}>{item.inspection}</Typography>
                                                <Divider sx={{ mt: 1 }} />

                                                <Box sx={{ width: '100%' }}>
                                                  <BarChart
                                                    xAxis={[
                                                      {
                                                        scaleType: 'band',
                                                        data: resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.year)
                                                      }
                                                    ]}
                                                    series={[{ data: resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result) }]}
                                                    colors={['#85bae1', '#85e1e0', '#85e1c8']}
                                                    height={130}
                                                    barLabel="value"
                                                    borderRadius={13}
                                                    leftAxis={null}
                                                    margin={{ left: 0, right: 0, top: 20, bottom: 20 }}
                                                    sx={{
                                                      '& .MuiBarLabel-root': { fill: '#fff' }
                                                    }}
                                                  />
                                                </Box>

                                                <Stack direction={'row'} alignItems={'center'} justifyContent="space-around" mt={1}>
                                                  {resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((itemSub: any, index: any, { length }) => (
                                                    itemSub.inspection === '비만도(BMI)'
                                                      ?
                                                      <Box sx={{}}>
                                                        <Chip
                                                          label={
                                                            item.result < '18.5' ? '저체중' : item.result >= '18.5' && item.result < '23.0' ? '정상' : item.result >= '23.0' && item.result < '25.0' ? '과체중' : item.result >= '25.0' && item.result < '30.0' ? '비만' : item.result >= '30.0' ? '고도비만' : ''
                                                          }
                                                          color="primary"
                                                          size='small'
                                                          sx={{
                                                            bgcolor: item.result < '18.5' ? 'rgb(189, 186, 26)' : item.result >= '18.5' && item.result < '23.0' ? 'rgb(0, 170, 0)' : item.result >= '23.0' && item.result < '25.0' ? 'rgb(179, 95, 214)' : item.result >= '25.0' && item.result < '30.0' ? 'rgb(255, 85, 85)' : item.result >= '30.0' ? 'rgb(229,36,36)' : '',
                                                            fontSize: 12,
                                                          }}
                                                        />
                                                      </Box>
                                                      :
                                                      <Box sx={{}}>
                                                        <Chip label={itemSub.resultCase === 'B' ? (
                                                          itemSub.resultRatio < 33 ? '낮음' : itemSub.resultRatio >= 33 && itemSub.resultRatio <= 66 ? '정상' : itemSub.resultRatio > 66 ? '높음' : ''
                                                        ) : (
                                                          itemSub.resultRatio < 50 ? '비정상' : '정상'
                                                        )} color="primary" size='small' sx={{
                                                          bgcolor: itemSub.resultCase === 'B' ? (
                                                            itemSub.resultRatio < 33 ? '#ff6f6f' : itemSub.resultRatio >= 33 && itemSub.resultRatio <= 66 ? '#2bbe43' : itemSub.resultRatio > 66 ? '#ff6f6f' : ''
                                                          ) : (
                                                            itemSub.resultRatio < 50 ? '#ff6f6f' : '#2bbe43'
                                                          ), fontSize: 12,
                                                        }} />
                                                      </Box>
                                                  ))}
                                                </Stack>
                                                <Typography sx={{ fontSize: 13, textAlign: 'center', mt: 1.5, color: '#777' }}>{item.normalRange}</Typography>
                                                {
                                                  resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result).length > 1 ? (
                                                    <Box sx={{ bgcolor: '#f7f7f7', p: 1, mt: 1 }}>
                                                      <Typography sx={{ fontSize: 13, textAlign: 'center', color: '#555' }}>{'직전연도 결과값 대비 '}
                                                        {resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result)[
                                                          resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result).length - 1
                                                        ] - resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result)[
                                                          resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result).length - 2
                                                          ]}
                                                        {' 증가'}</Typography>
                                                    </Box>
                                                  ) : null
                                                }
                                              </Card>
                                            </React.Fragment>
                                          )}
                                        </React.Fragment>
                                      ) : (null)
                                    ))}

                                  </React.Fragment>
                                ))}

                              </React.Fragment>
                            ))}
                          </Box>
                        </Box>
                      ))}

                      <Typography pl={3} mt={3} sx={mainTitle}>종합소견</Typography>

                      <Stack direction="row" spacing={0} sx={{ mt: 3 }}>
                        <ToggleButtonGroup
                          value={alignment}
                          exclusive
                          onChange={handleAlignment}
                          aria-label="text alignment"
                          sx={{ width: '100%', bgcolor: '#fff' }}
                        >

                          {resultData && resultData.map((item: any, index: any) => (
                            <ToggleButton value={item.year.substring(0, 4)} aria-label={item.year.substring(0, 4)} sx={toggleBtn} onClick={() => (
                              setTotalResult(item.totalResult.split('\r\n\r\n'))
                            )}>
                              <HealthAndSafetyIcon fontSize='small' />
                              <Typography>{item.year.substring(0, 4)}</Typography>
                            </ToggleButton>
                          ))}

                        </ToggleButtonGroup>
                      </Stack>


                      <Box sx={{ p: 2, bgcolor: '#f9f9f9', '& p': { wordBreak: 'keep-all' } }}>
                        {totalResult && totalResult.map((item: any) => (
                          <Card sx={resultBox}>
                            <Typography sx={resultTotal}>{item}</Typography>
                          </Card>
                        ))}
                      </Box>

                    </React.Fragment>
                  )}

                </React.Fragment>

              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', m: 1 }}>
              <Button autoFocus onClick={handleClose} sx={{ bgcolor: '#0d6703', color: '#fff', width: 200, borderRadius: 6, '&:hover': { bgcolor: '#074300' } }}>
                확인
              </Button>
            </DialogActions>
          </BootstrapDialog>
          {/* <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
           >
            <Box
              sx={{ pb: 7, }}
              role="presentation"
              onKeyDown={toggleDrawer(props.anchor, false)}
             >
              <Stack direction={'row'} justifyContent={'center'} mb={1} p={2} sx={{ position: 'fixed', width: '100%', bgcolor: '#fff', zIndex: 1, boxSizing: 'border-box', borderBottom: '1px solid #ccc' }}>
                <Typography sx={{ fontSize: 18, fontWeight: 700, ml: 'auto', }}>{props.componentName.replaceAll('<br />', ' / ')}</Typography>
                <Typography sx={{ fontSize: 18, fontWeight: 700, ml: 'auto', mr: 1, color: '#777' }} onClick={toggleDrawer(props.anchor, false)}>X</Typography>
              </Stack>


              <React.Fragment>
                <Box sx={{ bgcolor: '#fff', p: 1, textAlign: 'right', pr: 2, pt: 10 }}>
                  <Typography sx={{ fontSize: 14, }}>검진항목 <Typography component={'span'} sx={{ fontSize: 14, fontWeight: 700 }}>{resultItemData.length}</Typography>개</Typography>
                </Box>
                <Divider />
                
                {categoryB.length <= 0 ? (
                  <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 10, }}>
                    <EventBusyIcon sx={{ fontSize: 50, color: '#bbb' }} />
                    <Typography sx={{ fontSize: 16, color: '#888' }} >{props.componentName.replaceAll('<br />', ' / ')} 정보가 없습니다.</Typography>
                  </Stack>
                ) : (
                  categoryA && categoryA.map((itemA: any, index: any) => (
                    <Box sx={{ mt: 3, }}>
                      <Typography pl={3} sx={mainTitle}>{itemA}</Typography>
                      <Box sx={{ p: 2, bgcolor: '#f9f9f9', }}>
                
                        {categoryB && categoryB.map((itemB: any, index1: number) => (
                          <React.Fragment>
                            
                            {resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB).map((item: any, index11: number) => (
                                index11 === 0 ? <Divider sx={titleDivider} >{itemB}</Divider> : null
                            ))}
                            
                            {categoryC && categoryC.map((itemC: any, index: any) => (
                              <React.Fragment>
                                
                                {resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((item: any, index: number) => (
                                  index === 0 ? (
                                    <React.Fragment>

                                      {item.resultCase === 'A' ? (
                                        <React.Fragment>
                                          
                                          <Card sx={resultBox}>
                                            <Typography sx={resultTitle}>{item.inspection}</Typography>
                                            <Divider sx={{ mt: 1 }} />
                        
                                            <Stack direction={'row'} justifyContent={'space-around'} mt={1}>
                                              {resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((itemSub: any, index: any, {length}) => (
                                                <React.Fragment>
                                                  <Box sx={{ textAlign: 'center' }}>
                                                    <Chip label={itemSub.year} size='small' />
                                                    <Typography sx={result}>{util.strNull(itemSub.result).trim() !== '' ? itemSub.result : '-'}
                                                      <Typography component={'span'} sx={resultUnit}>{itemSub.unit}</Typography>
                                                    </Typography>
                                                  </Box>
                                                  {index+1 !== length ? (<Divider orientation="vertical" flexItem sx={divider} />) : null}
                                                </React.Fragment>
                                              ))}
                                            </Stack>
                                          </Card>
                        
                                        </React.Fragment>
                                      ) : (
                                        <React.Fragment>
                                          
                                          <Card sx={resultChartBox}>
                        
                                            {item.resultCase === 'B' ? (
                                              <Box sx={{ mt: 1 }}>
                                                <Box sx={{ width: '100%', textAlign: 'center' }}>
                                                  <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 15px)`, }}>
                                                    <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {item.result}</Typography>
                                                    <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                                  </Box>
                                                </Box>
                        
                                                <Grid container spacing={0} height={10} sx={{ mt: -1.5, mb: 1 }}>
                                                  <Grid item xs={4} bgcolor={'rgb(189,186,26)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                    낮음
                                                  </Grid>
                                                  <Grid item xs={4} bgcolor={'rgb(29,159,55)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                    정상
                                                  </Grid>
                                                  <Grid item xs={4} bgcolor={'rgb(229,36,36)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                    높음
                                                  </Grid>
                                                </Grid>
                        
                                             
                                              </Box>
                        
                        
                                            ) : (
                                              <Box sx={{ mt: 1 }}>
                                                <Box sx={{ width: '100%', textAlign: 'center' }}>
                                                  <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 15px)`, }}>
                                                    <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {item.result}</Typography>
                                                    <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                                  </Box>
                                                </Box>
                        
                                                <Grid container spacing={0} height={10} sx={{ mt: -1.5, mb: 1 }}>
                                                  <Grid item xs={6} bgcolor={'rgb(229,36,36)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                    비정상
                                                  </Grid>
                                                  <Grid item xs={6} bgcolor={'rgb(29,159,55)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                    정상
                                                  </Grid>
                                                </Grid>
                                              </Box>
                                              
                                            )} */}

          {/* 3개년 비교
                                            <Typography sx={resultTitle}>{item.inspection}</Typography>
                                            <Divider sx={{ mt: 1 }} />
                                            
                                            <Box sx={{ width: '100%' }}>
                                              <BarChart
                                                xAxis={[
                                                  {
                                                    scaleType: 'band',
                                                    data: resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.year)
                                                  }
                                                ]}
                                                series={[{ data: resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result) }]}
                                                colors={['#85bae1','#85e1e0','#85e1c8']}
                                                height={130}
                                                barLabel="value"
                                                borderRadius={13}
                                                leftAxis={null}
                                                margin={{ left: 0, right: 0, top: 20, bottom: 20 }}
                                                sx={{
                                                  '& .MuiBarLabel-root' : {fill:'#fff'}
                                                }}
                                              />
                                            </Box>
                                     
                                              <Stack direction={'row'} alignItems={'center'} justifyContent="space-around" mt={1}>
                                                {resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((itemSub: any, index: any, {length}) => (
                                                  <Box sx={{}}>
                                                    <Chip label={itemSub.resultCase === 'B' ? (
                                                      itemSub.resultRatio < 33 ? '낮음' : itemSub.resultRatio >= 33 && itemSub.resultRatio <= 66 ? '정상' : itemSub.resultRatio > 66 ? '높음' : ''
                                                    ) : (
                                                      itemSub.resultRatio < 50 ? '비정상' : '정상'
                                                    )} color="primary" size='small' sx={{ bgcolor: itemSub.resultCase === 'B' ? (
                                                      itemSub.resultRatio < 33 ? '#ff6f6f' : itemSub.resultRatio >= 33 && itemSub.resultRatio <= 66 ? '#2bbe43' : itemSub.resultRatio > 66 ? '#ff6f6f' : ''
                                                    ) : (
                                                      itemSub.resultRatio < 50 ? '#ff6f6f' : '#2bbe43'
                                                    ), fontSize: 12, }} />
                                                  </Box>
                                                ))}
                                              </Stack>
                                              <Typography sx={{fontSize:13, textAlign:'center',mt:1.5, color:'#777'}}>{item.normalRange}</Typography>
                                               {
                                                resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result).length > 1 ? (
                                                  <Box sx={{bgcolor:'#f7f7f7', p:1, mt:1}}>
                                                    <Typography sx={{fontSize:13, textAlign:'center', color:'#555'}}>{'직전연도 결과값 대비 '}
                                                      {resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result)[
                                                          resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result).length-1
                                                        ] - resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result)[
                                                          resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB && v.ipCode === itemC).map((v: any) => v.result).length-2
                                                        ]}
                                                      {' 증가'}</Typography>
                                                  </Box>
                                                ) : null
                                              }
                                          </Card>
                                        </React.Fragment>
                                      )}
                                    </React.Fragment>
                                  ) : (null)
                                ))}
                                
                              </React.Fragment>
                            ))}
                            
                          </React.Fragment>
                        ))}
                      </Box>
                    </Box>
                  ))
                )}
                
                
                <Typography pl={3} mt={3} sx={mainTitle}>종합소견</Typography>

                
                <Stack direction="row" spacing={0} sx={{ mt: 3 }}>
                  <ToggleButtonGroup
                    value={alignment}
                    exclusive
                    onChange={handleAlignment}
                    aria-label="text alignment"
                    sx={{ width: '100%', bgcolor: '#fff' }}
                  >

                    {resultData && resultData.map((item: any, index: any) => (
                      <ToggleButton value={item.year.substring(0, 4)} aria-label={item.year.substring(0, 4)} sx={toggleBtn} onClick={() => (
                        setTotalResult(item.totalResult.split('\r\n\r\n'))
                      )}>
                        <HealthAndSafetyIcon fontSize='small' />
                        <Typography>{item.year.substring(0, 4)}</Typography>
                      </ToggleButton>
                    ))}
          
                  </ToggleButtonGroup>
                </Stack>
                
                
                <Box sx={{ p: 2, bgcolor: '#f9f9f9', }}>
                  {totalResult && totalResult.map((item: any) => (
                    <Card sx={resultBox}>
                      <Typography sx={resultTotal}>{item}</Typography>
                    </Card>
                  ))}
                </Box>

              </React.Fragment>



            </Box>
          </SwipeableDrawer> */}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}

const mainTitle = {
  fontSize: 18,
  fontWeight: 700,
  mb: 1,
  background: '#8b8b8b',
  color: '#fff',
  padding: '8px 20px 5px',
  width: '30%',
  borderRadius: '20px',
  textAlign: 'center'
}

const titleDivider = {
  mt: 1, mb: 2, fontWeight: 700,
  '& span': { bgcolor: '#ddd', borderRadius: 4, py: .5, px: 2, fontSize: 14 }
}

const resultBox = {
  p: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', mb: 2
}

const resultChartBox = {
  p: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', mb: 2
}

const resultTitle = {
  fontSize: 14,
  flex: 1,
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

const result = {
  fontSize: 14,
  fontWeight: 700,
  flex: 1,
  textAlign: 'left',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  mt: 1,
}

const resultUnit = {
  fontSize: 12,
  ml: .5
}

const divider = {
  mx: 1,
}

const resultTotal = {
  fontSize: 14,
}



const resultIconBtn = {
  bgcolor: '#f9f9f9', p: 1, borderRadius: 4, textAlign: 'center', width: 70, minHeight: 60,
  '& p': { fontSize: 12, color: '#555', textAlign: 'center', }
}

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const bmiStep = {
  p: '0 !important',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center'
}

const toggleBtn = {
  p: 0,
  pt: 1,
  pb: 1,
  flex: '1 1 auto',
  '& .MuiSvgIcon-root': { pl: .3 },
  '& p': { fontSize: 14, p: 0, pl: 1 },
  '&.Mui-selected p': { fontWeight: 700 }

}

export default HealthResultCompare;